var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-menu"},[_c('ul',[_c('li',{on:{"click":_vm.toggle}},[_c('edit-profile-button')],1),_vm._v(" "),_c('li',[_c('logout-button')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }